module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "lndon"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("If There Is I Haven’t Found It Yet")]), _vm._v(" had its world premiere in London on October 17, 2009, at the Bush Theatre.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Cast")])]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("GEORGE")]), _vm._v(" Michael Begley")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIONA")]), _vm._v(" Pandora Colin")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANNA")]), _vm._v(" Ailish O’Connor")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TERRY")]), _vm._v(" Rafe Spall")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Creative Team")])]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DIRECTOR")]), _vm._v(" Josie Rourke")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DESIGNER")]), _vm._v(" Lucy Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIGHTING DESIGNER")]), _vm._v(" Oliver Fenwick")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SOUND DESIGNER")]), _vm._v(" Emma Laxton")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ASSISTANT DIRECTOR")]), _vm._v(" Ant Stones")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COMPANY STAGE MANAGER")]), _vm._v(" Angela Riddell")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DEPUTY STAGE MANAGER")]), _vm._v(" Dave Blakemore")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SCENIC ARTIST")]), _vm._v(" Lara Etherton")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DESIGN ASSISTANT")]), _vm._v(" James Turner")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STAGE MANAGER (COVER)")]), _vm._v(" Xenia Lewis")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PRODUCTION ELECTRICIAN")]), _vm._v(" Chole Kenward")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f902bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/lond-prod.vue
// module id = 78
// module chunks = 0